export const base_url = "https://dev.paidpromo.ai/api" // dev base URL

// export const youtube_redirect_uri = "http://localhost:3000/influencer-channel" // local base URL
export const youtube_redirect_uri = "https://dev.paidpromo.ai/influencer-channel" // dev base URL
export const youtube_redirect_uri_auth_only = "https://dev.paidpromo.ai/influencer-channel-auth" // dev base URL
export const instagram_redirect_uri = `${window.location.origin}/influencer/choose-access-type`;


export const stripe_onboarding_callback = "https://dev.paidpromo.ai/influencer/transactions?status=" // local base URL
// export const stripe_onboarding_callback = "http://localhost:3000/influencer/transactions?status=" // local base URL

export const APPLE_CONFIG = {
    clientId: 'com.app.paidpromo.service',
    redirectUri: `https://dev.paidpromo.ai/` // Added trailing slash as required by Apple
};

export const payment_redirect_uri = "https://dev.paidpromo.ai/brand/transactions?sessionId={CHECKOUT_SESSION_ID}&paymentStatus=success" // local base URL
export const payment_redirect_urii = "https://dev.paidpromo.ai/brand/campaigns/create?sessionId={CHECKOUT_SESSION_ID}&paymentStatus=success" // local base URL
export const payment_redirect_uri_agency = "https://dev.paidpromo.ai/agency/transactions?sessionId={CHECKOUT_SESSION_ID}&paymentStatus=success" // local base URL
export const payment_redirect_urii_agency = "https://dev.paidpromo.ai/agency/campaigns/create?sessionId={CHECKOUT_SESSION_ID}&paymentStatus=success" // local base URL
// export const payment_redirect_uri = "http://localhost:3000/brand/transactions?sessionId={CHECKOUT_SESSION_ID}&paymentStatus=" // local base URL

export const endpoints = {
    login: "/paidpromo/auth/login", // Generate OTP
    googleUserLogin: "/paidpromo/auth/googleUserLogin", // Google OAuth login
    appleUserLogin: "/paidpromo/auth/appleUserLogin", // Apple OAuth login (popup flow)
    getUserInfo: "/paidpromo/user/me", // Get Logged in User Details
    createUser: "/paidpromo/user/sendOtpToCreateUser", // Send Otp To Create User
    verifyOtpAndCreateUser: "/paidpromo/user/verifyOtpAndCreateUser", // Verify Otp To Create User
    sendOtpForForgetPassword: "/paidpromo/auth/sendOtpForForgetPassword", // send Otp For Forget Password
    verifyOtpForForgetPassword: "/paidpromo/auth/verifyOtpForForgetPassword", // verify Otp For Forget Password
    forgetPasswordReset: "/paidpromo/auth/forgetPasswordReset", // reset Forget Password
    getAllCountry: "/paidpromo/country/getAllCountry", // reset Forget Password
    sendOtpToCreateUser: "/paidpromo/user/sendOtpToCreateUser",
    userLogin: "/paidpromo/auth/userLogin",
    verifyOtpForLogin: "/paidpromo/auth/verifyOtpForLogin",
    getAllRegion: "/paidpromo/region/getAllRegion",
    getCountryByRegion: "/paidpromo/country/getCountryByRegion?regionId=",
    getStateByCountry: "/paidpromo/state/getStateByCountry?countryId=",
    getAllAgeGroup: "/paidpromo/ageGroup/getAllAgeGroup",
    getAllNiche: "/paidpromo/niche/getAllNiche",
    getBudget: "/paidpromo/campaign/getBudget",
    getMaxViews: "/paidpromo/campaign/getMaxViews",
    getBrandCampaign: "/paidpromo/campaign/getBrandCampaign",
    getAllBannerTemplate: "/paidpromo/bannerTemplate/getAllBannerTemplate",
    uploadCampaignFile: "/paidpromo/campaign/uploadCampaignFile",
    uploadVideoCampaignFileBrand: "/paidpromo/campaign/uploadVideoCampaignFileBrand",
    uploadBgcVideo: "/paidpromo/campaign/uploadBgcVideo",

    createCampaign: "/paidpromo/campaign/createCampaign",
    getMyBrandBusinessDetail: "/paidpromo/brandBusiness/getMyBrandBusinessDetail",
    searchBusinessPlace: "/paidpromo/brandBusiness/searchBusinessPlace",
    registerBusiness: "/paidpromo/brandBusiness/registerBusiness",
    myChannelList: "/paidpromo/influencerPlatformChannel/myChannelList",
    storeYoutubeAuth: "/paidpromo/influencerPlatformAccount/storeYoutubeAuth",
    getYoutubeChannelList: "/paidpromo/influencerPlatformAccount/getYoutubeChannelList",
    storeValidateChannel: "/paidpromo/influencerPlatformChannel/storeValidateChannel",
    getCampaignListWithFilter: "/paidpromo/campaign/getCampaignListWithFilter",
    uploadInfluencerVideo: "/paidpromo/contentUpload/uploadInfluencerVideo?contentPath=",
    optAndSubmitContent: "/paidpromo/campaign/optAndSubmitContent",
    checkContentMergeStatus: "/paidpromo/campaign/checkContentMergeStatus",
    publishVideoOnYoutube: "/paidpromo/contentUpload/publishVideoOnYoutube",
    resubmissionOptAndSubmitContentUGC: "/paidpromo/campaign/resubmissionOptAndSubmitContentUGC",
    uploadToS3: "",
    streamVideo: "/paidpromo/contentUpload/streamVideo",
    getUploadedUGCContentList: "/paidpromo/contentUpload/getUploadedUGCContentList",
    markApprovedRejectedContent: "/paidpromo/contentUpload/markApprovedRejectedContent",
    getUploadedUGCContentForInfluencer: "/paidpromo/contentUpload/getUploadedUGCContentForInfluencer",
    getWalletTxnWithFilter: "/paidpromo/walletTxn/getWalletTxnWithFilter",
    addMoneyToWallet: "/paidpromo/wallet/addMoneyToWallet",
    txnStatus: "/paidpromo/wallet/txnStatus",
    stripeOnboarding: "/paidpromo/wallet/stripeOnboarding",
    checkStripeOnboardingStatus: "/paidpromo/wallet/checkStripeOnboardingStatus",
    requestPayout: "/paidpromo/wallet/requestPayout",
    getCampaignDetailsForDashboard: "/paidpromo/campaign/influencer/dashboard",
    getPotentialIncomeMissedByMonthAndYearForDashboard: "/paidpromo/campaign/getPotentialIncomeMissedByMonthAndYearForDashboard",
    getTotalIncomeByMonthAndYearForDashboard: "/paidpromo/campaign/getTotalIncomeByMonthAndYearForDashboard",
    getDashboardData: "/paidpromo/campaign/getDashboardData",
    getCampaignListWithFilterDashBoard: "/paidpromo/campaign/getCampaignListWithFilterDashBoard",
    getAllConfigPropertiesForBrandAndInfluencer: "/paidpromo/configProperties/getAllConfigPropertiesforBrandAndInfluencer",
    optCampaignNotPublished: "/paidpromo/campaign/optCampaignNotPublished",
    getOptedCampaignsListByBrand: '/paidpromo/brand/getOptedCampaignsListByBrand',
    getOptedCampaignsDetailsByInfluencer: '/paidpromo/influencer/getOptedCampaignsDetailsByInfluencer',
    optUGCCampaign: '/paidpromo/campaign/optUGCCampaign',
    viewUGCContentforInfluencer: '/paidpromo/contentUpload/viewUGCContentforInfluencer',
    sendOtpForMobileVerified: '/paidpromo/user/sendOtpForMobileVerified',
    verifyMobileOtp: '/paidpromo/user/verifyMobileOtp',
    loggedInInfluencerChannelList: '/paidpromo/influencerPlatformChannel/loggedInInfluencerChannelList',
    downloadContentForManualUpload: '/paidpromo/contentUpload/downloadContentForManualUpload',
    optAndSubmitContentLink: '/paidpromo/campaign/optAndSubmitContentLink',
    sendOtpToCreateAgency: '/paidpromo/agency/sendOtpToCreateAgency', // Send Otp To Create Agency
    verifyOtpAndCreateAgencyUser: '/paidpromo/agency/verifyOtpAndCreateAgencyUser', // Verify Otp To Create Agency
    createCampaignByAgency: '/paidpromo/agency/createCampaignByAgency', // Create Campaign By Agency
    getAllAgencyUser: '/paidpromo/agencyUser/getAllAgencyUser', // Get All Agency User list
    markActiveInActiveAgencyUser: '/paidpromo/agencyUser/markActiveInActiveAgencyUser', // Mark Active Inactive Agency User
    createAgencyUser: '/paidpromo/agencyUser/createAgencyUser', // Create Agency User
    getMyBrandBusinessDetailForAgency: '/paidpromo/agency/getMyBrandBusinessDetailForAgency', // Get My Brand Business Detail For Agency
    searchBusinessPlaceForAgency: '/paidpromo/agency/searchBusinessPlaceForAgency', // Search Business Place For Agency
    createBrandByAgency: '/paidpromo/agency/createBrandByAgency', // Create Brand By Agency
    getWalletTxnWithFilterForAgency: '/paidpromo/agency/getWalletTxnWithFilterForAgency', // Get Wallet Txn With Filter For Agency
    getCityByState: '/paidpromo/city/getCityByState', // Get City By State
    uploadBgcVideoForAgency: '/paidpromo/agency/uploadBgcVideo', // Upload BGC Video For Agency
    uploadReferenceVideo: '/paidpromo/campaign/upload-reference-video', // Upload Reference Guidance Video
    uploadReferenceGuidanceVideo: '/paidpromo/campaign/uploadReferenceGuidanceVideo', // New API for returning S3 Path
    downloadReferenceVideo: '/paidpromo/campaign/download-reference-video', // Download Reference Guidance Video (pre-signed URL)
    getInfluencerProfile: '/paidpromo/influencerProfile/getProfile', // Get Influencer Profile
    saveInfluencerProfile: '/paidpromo/influencerProfile/saveProfile', // Save Influencer Profile
    uploadProfilePhoto: '/paidpromo/influencerProfile/uploadProfilePhoto', // Upload Profile Photo
    updateUserInfo: '/paidpromo/user/updateUser', // Update User Profile Info
    deactivateAccount: '/paidpromo/user/deactivate', // Deactivate Account
}
